import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import theme from './theme';
import Navbar from './components/Navbar';
import Home from './pages/home/Home';
import Family from './pages/familiares/Family';
import Admin from './pages/Admin';
import Emergency from './pages/emergencia/Emergency';
import AdminPanel from './pages/admin_panel/AdminPanel';
import ResetPassword from './pages/ResetPassword';
import PartnerEmergencies from './pages/emer_socorrista/PartnerEmergencies';
import Login from './pages/login/Login';
import EmergencySocorrista from './pages/emer_socorrista/EmergencySocorrista';
import FamilyEmergencies from './pages/familiares/FamilyEmergencies';
import FamilyEmergencyLocation from './pages/familiares/FamilyEmergencyLocation';
import EmergencyFamily from './pages/familiares/EmergencyFamily';
import ProtectedRoute from './components/ProtectedRoute';
import ChamadosClient from './cliente/chamadosClient';
import CustomMapWithAmbulanceIcon from './pages/emer_socorrista/CustomMapWithAmbulanceIcon';
import TelemedicinaClient from './pages/telemedicina/TelemedicinaClient';
import TelemedicinaTriagem from './pages/telemedicina/TelemedicinaTriagem';
import TelemedicinaMedico from './pages/telemedicina/TelemedicinaMedico';
import Carteirinha from './pages/carteirinha/Carteirinha';

const ProtectedLayout: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100dvh'
      }}
    >
      <Navbar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: `calc(56px + env(safe-area-inset-top))`, // altura navbar + safe area top
          pb: 'env(safe-area-inset-bottom)',          // safe area bottom (se precisar)
          px: { xs: 2, sm: 3 },
          bgcolor: 'background.default',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

const App: React.FC = () => {
  useEffect(() => {
    // Normalizar URL se começar com barra dupla (problema comum com redirects de e-mail)
    const currentPath = window.location.pathname;
    if (currentPath.startsWith('//')) {
      const normalizedPath = currentPath.replace(/^\/+/, '/');
      const newUrl = window.location.origin + normalizedPath + window.location.search + window.location.hash;
      window.location.replace(newUrl);
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Rota pública */}
          <Route path="/" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Rotas protegidas */}
          <Route element={<ProtectedRoute />}> 
            <Route element={<ProtectedLayout />}> 
              <Route path="/family" element={<Family />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/emergency" element={<Emergency />} />
              <Route path="/emergencia-socorrista" element={<EmergencySocorrista />} />
              <Route path="/admin-panel" element={<AdminPanel />} />
              <Route path="/home" element={<Home />} />
              <Route path="/partner-emergencies" element={<PartnerEmergencies />} />
              <Route path="/family-emergencies" element={<FamilyEmergencies />} />
              <Route path="/emergency-family" element={<EmergencyFamily />} />
              <Route path="/family-emergency-location" element={<FamilyEmergencyLocation />} />
              <Route path="/chamado-cliente" element={<ChamadosClient />} />
              <Route path="/custom-map-ambulance" element={<CustomMapWithAmbulanceIcon />} />
              <Route path="/telemedicina/cliente" element={<TelemedicinaClient />} />
              <Route path="/telemedicina/triagem" element={<TelemedicinaTriagem />} />
              <Route path="/telemedicina/medico" element={<TelemedicinaMedico />} />
              <Route path="/carteirinha" element={<Carteirinha />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App; 
